import { ref, toRefs, computed, reactive, watch, unref } from 'vue'
import { Message } from 'view-design'
import { getBarrageList, getXijingPages, getPromotedObject } from '@/api/tencent.model'
import { MEDIAS } from '@/common/js/constants.js'
import {
  LINK_NAME_TYPE,
  LINK_NAME_TYPE_MINIGAME,
  SELECTOR_TYPE,
  MATERIAL_SIZES,
  BRAND_ENUM
} from '@/views/create/gdt/model/creative-const.js'
import { makeSelectorForm } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { getWxGamePlayablePage } from '@/api/tencent.local.model'
export const emojiRegExp = new RegExp(/\[(.*?)\]/, 'g')

export const useActionButton = (platform) => {
  const linkNameTypes = computed(() => {
    return platform.value.isMiniGame ? LINK_NAME_TYPE_MINIGAME : LINK_NAME_TYPE
  })

  return {
    linkNameTypes
  }
}

export const useIconSelector = () => {
  const iconSelecotrModel = reactive({
    selectorModal: false,
    selectorFlag: '',
    wxgamePlayableFlag: '',
    selectorProps: {
      max: 1,
      assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO],
      form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_800_800, media_id: MEDIAS.GDT }
    }
  })

  /**
   * @description:
   * @param {*} selectorFlag icon 类型标记
   * @return {*}
   */
  function showIconSelector(selectorFlag, wxgamePlayableFlag = '') {
    iconSelecotrModel.selectorFlag = selectorFlag
    iconSelecotrModel.wxgamePlayableFlag = wxgamePlayableFlag
    iconSelecotrModel.selectorModal = true
  }

  function onSelectorClose() {
    iconSelecotrModel.selectorFlag = ''
    iconSelecotrModel.wxgamePlayableFlag = ''
    iconSelecotrModel.selectorModal = false
  }

  return {
    ...toRefs(iconSelecotrModel),
    showIconSelector,
    onSelectorClose,
    SELECTOR_TYPE
  }
}

export const useMiniCardLink = (creativeForm) => {
  const miniCardLinkDescriptionRef = ref(null)
  const miniCardLinkDescriptionInputRef = ref(null)
  function onMiniCardLinkSelectorConfirm(assets) {
    const components = creativeForm.value.components
    components.mini_card_link.mini_card_link_image = assets[0]
    creativeForm.value.components = components
  }

  function insertMiniCardLinkDescText(text) {
    const inputEl = miniCardLinkDescriptionInputRef.value.$el.querySelector('input')
    miniCardLinkDescriptionRef.value.initEventListeners()

    const matchedItems = inputEl.value.match(emojiRegExp) || []
    if (matchedItems.length > 0) return Message.warning('只能插入一个表情')

    if (!inputEl) return
    inputEl.setRangeText(text, inputEl.selectionStart, inputEl.selectionEnd, 'end')
    inputEl.focus()
    const components = creativeForm.value.components
    components.mini_card_link.mini_card_link_description = inputEl.value
    creativeForm.value.components = components
  }

  return {
    miniCardLinkDescriptionRef,
    miniCardLinkDescriptionInputRef,
    insertMiniCardLinkDescText,
    onMiniCardLinkSelectorConfirm
  }
}

export const useBarrage = (getAdAccount, creativeForm) => {
  const barrageModel = reactive({
    barrageList: []
  })
  /**
   * @description: 获取弹幕
   */
  function getComponentsBarrageList() {
    getBarrageList({ ad_account_id: getAdAccount().id }).then((data) => {
      barrageModel.barrageList = data
    })
  }

  function onBarrageClear() {
    creativeForm.value.components.barrage = []
  }

  getComponentsBarrageList()

  return {
    ...toRefs(barrageModel),
    getComponentsBarrageList,
    onBarrageClear
  }
}

export const useLabel = (creativeForm) => {
  const labelModel = reactive({
    labelModal: false,
    labelList: []
  })

  function onClearRemove() {
    creativeForm.value.components.label = []
  }

  /**
   * @description: 选择标签
   */
  function onConfirmLabels(labels) {
    const components = creativeForm.value.components
    components.label = labels
    creativeForm.value = {
      ...creativeForm.value,
      components
    }
  }
  return {
    ...toRefs(labelModel),
    onConfirmLabels,
    onClearRemove
  }
}

export const useFloatingZone = (creativeForm) => {
  function onFloatingZoneSelectorConfirm(assets) {
    const components = creativeForm.value.components
    components.floating_zone.floating_zone_image = assets[0]
    creativeForm.value.components = components
  }
  return {
    onFloatingZoneSelectorConfirm
  }
}

export const useWxgamePlayableCustom = (creativeForm) => {
  function onWxgamePlayableSelectorConfirm(assets) {
    const components = creativeForm.value.components
    components.wxgame_playable_page.wxgame_playable_page_end_cover_img = assets[0]
    creativeForm.value.components = components
  }
  return {
    onWxgamePlayableSelectorConfirm
  }
}

export const useWxgamePlayableComponent = (creativeForm) => {
  function onWxgamePlayableCompSelectorConfirm(assets, wxgamePlayableImgProp) {
    const components = creativeForm.value.components
    components.wxgame_playable_component[wxgamePlayableImgProp] = assets[0]
    creativeForm.value.components = components
  }
  return {
    onWxgamePlayableCompSelectorConfirm
  }
}

/**
 * @description: 批量复制、批量修改时使用
 * @return {*}
 */
export const useWxGamePlayableSelector = (planForm, creativeForm, isWxGamePlayable) => {
  const wxgamePlayableList = ref([])

  watch(
    () => planForm.value.promotedObject?.promoted_object_id,
    (promoted_object_id) => {
      if (promoted_object_id) {
        wxGameQueryAction()
      }
    }
  )

  function wxGameQueryAction(accountId) {
    const { accounts, promotedObject } = unref(planForm) || {}
    const { promoted_object_id } = promotedObject || {}
    const [ad_account_id] = accountId ? [accountId] : accounts || []
    if (promoted_object_id && ad_account_id) {
      getWxGamePlayablePage({ ad_account_id, appId: unref(planForm).promotedObject.promoted_object_id }).then((data) => {
        wxgamePlayableList.value = data.map((row) => {
          return {
            ...row,
            status_text: row.status === 'PLAYABLE_PAGE_STATUS_ONLINE' ? '版本在线' : '版本下线'
          }
        })

        // 试玩素材切换账号后判断是否清空下拉选择
        if (isWxGamePlayable.value) {
          const hasPlayablePage = wxgamePlayableList.value.some(
            (item) => item.playable_page_path === creativeForm.value.components.wxgame_playable_material_config?.playable_page_path
          )

          if (!hasPlayablePage) {
            if (creativeForm.value.components.wxgame_playable_material_config) {
              creativeForm.value.components.wxgame_playable_material_config.playable_page_path = ''
            }
          }
        }
      })
    }
  }

  return {
    wxgamePlayableList,
    wxGameQueryAction
  }
}

export const useFirstComment = (creativeForm) => {
  // const emojiRegExp = new RegExp(/\[(.*?)\]/, 'g')
  const commentRef = ref(null)
  const commentInputRef = ref(null)

  function insertText(text) {
    const inputEl = commentInputRef.value.$el.querySelector('input')
    commentRef.value.initEventListeners()

    if (text === '#') {
    } else {
      const matchedItems = inputEl.value.match(emojiRegExp) || []
      if (matchedItems.length > 0) return Message.warning('只能插入一个表情')
    }

    // 插入文本，头条2.0 模板新建计划创意信息新增首评回复
    if (!inputEl) return
    inputEl.setRangeText(text, inputEl.selectionStart, inputEl.selectionEnd, 'end')
    inputEl.focus()

    const components = creativeForm.value.components
    components.social_skill.social_skill_first_comment = inputEl.value
    creativeForm.value.components = components
  }

  return {
    // emojiRegExp,
    commentRef,
    commentInputRef,
    insertText
  }
}
